import {connect} from 'react-redux';
import MainPage from '../../components/pages/MainPage';
import {getTicket} from '../../actions/cashRegisterAction';

const mapStateToProps = state => {
    return {
        roles: state.authorization.roles,
        addLocationDialogOpen: state.addLocation.addLocationDialogOpen
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getTicket: (ean) => {
            dispatch(getTicket(ean))
        }
    }
};

const MainPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MainPage);

export default MainPageContainer;
